/**
 * OAuth ITI CAS staging (gov.br) — client_id no browser; segredo só na Edge.
 * @see docs/internal/ITI_CAS_E2E_CHECKPOINT.md
 */

export const SYNAP_ITI_OAUTH_STORAGE_KEY = 'synap_iti_oauth_result'

export const itiPublicCasBase = (): string => {
  const v = import.meta.env.VITE_ITI_CAS_BASE_URL as string | undefined
  return (v?.trim() || 'https://cas.staging.iti.br').replace(/\/$/, '')
}

export const itiPublicClientId = (): string =>
  (import.meta.env.VITE_ITI_CLIENT_ID as string | undefined)?.trim() ?? ''

export const defaultItiRedirectPath = '/auth/iti/callback'

export const buildDefaultItiRedirectUri = (): string => {
  const explicit = (import.meta.env.VITE_ITI_REDIRECT_URI as string | undefined)?.trim()
  if (explicit) return explicit
  if (typeof window === 'undefined') return 'http://127.0.0.1:4173/auth/iti/callback'
  const { protocol, hostname, port } = window.location
  const host = hostname === 'localhost' ? '127.0.0.1' : hostname
  const portPart = port ? `:${port}` : ''
  return `${protocol}//${host}${portPart}${defaultItiRedirectPath}`
}

export const buildItiAuthorizeUrl = (opts: {
  clientId: string
  codeChallenge: string
  redirectUri: string
  state: string
  scope?: string
}): string => {
  const base = `${itiPublicCasBase()}/oauth2.0/authorize`
  const params = new URLSearchParams({
    response_type: 'code',
    client_id: opts.clientId.trim(),
    redirect_uri: opts.redirectUri.trim(),
    scope: (opts.scope ?? 'sign').trim(),
    state: opts.state,
    code_challenge: opts.codeChallenge.trim(),
    code_challenge_method: 'S256',
  })
  return `${base}?${params.toString()}`
}

export const isItiOAuthAvailable = (): boolean => Boolean(itiPublicClientId())

/**
 * E2E: Edge possui `ITI_E2E_REFRESH_TOKEN` — UI pula OAuth interativo.
 * Ativar só em build de teste (`VITE_ITI_E2E_EDGE_REFRESH=true`); nunca expõe o token no bundle.
 */
export const isItiE2eEdgeRefreshEnabled = (): boolean =>
  (import.meta.env.VITE_ITI_E2E_EDGE_REFRESH as string | undefined)?.trim().toLowerCase() === 'true'
